export const CommunicationTypeEnum = Object.freeze({
  Registration: 1,
  BeforeEvent: 2,
  AfterEvent: 3,
});
